import { render, staticRenderFns } from "./FCCCompetitionDetails.vue?vue&type=template&id=7f5779b4"
import script from "./FCCCompetitionDetails.vue?vue&type=script&lang=js"
export * from "./FCCCompetitionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports